export default __webpack_public_path__ + "static/media/MIR.77b54f6d.png";